'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require('redux');

var _reactRouterRedux = require('react-router-redux');

var _cms = require('./cms');

var _cms2 = _interopRequireDefault(_cms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Combine all the reducers
var rootReducer = (0, _redux.combineReducers)({
  cms: _cms2.default,
  routing: _reactRouterRedux.routerReducer
});

// Export
/**
 * Redux reducers
 */
exports.default = rootReducer;


//////////////////
// WEBPACK FOOTER
// ./src/reducers/index.js
// module id = 357
// module chunks = 1